module.exports = __webpack_public_path__ + "img/courses-data-science.046d4e3b.svg";